import { Outlet } from "react-router-dom";
import Navbar from "./Header.jsx";
import Footer from "./Footer.jsx";
import Sidebar from "./Sidebar.jsx";

const Layout = () => {
  const headerHeight = 60;

  return (

    
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Content area starts AFTER fixed header */}
      <div style={{ display: 'flex', flex: 1, marginTop: `${headerHeight}px` }}>
        <Sidebar />

        <main style={{
          flex: 1,
          padding: '1rem',
          overflowX: 'hidden',
        }}>
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;
